import { isPresent } from '@ember/utils'
import type {
  ResearchReportEntry,
  TeacherGuideEntry,
  CurriculumMapEntry,
  CertificateEntry,
} from 'teacher-ui-client/contentful-client/entry-types'

export function getResearchReportsViewModel(entries: ResearchReportEntry[]) {
  return (
    entries?.map((entry) => {
      return {
        title: entry.fields.title,
        description: entry.fields.description,
        subscriptionType: entry.fields.subscriptionType,
        coverUrl: entry.fields.cover?.fields.file?.url,
        fileUrl: entry.fields.file?.fields.file?.url,
      }
    }) || []
  )
}

export function getTeacherGuidesViewModel(entries: TeacherGuideEntry[]) {
  return entries
    ?.filter((entry) => entry.fields.cover?.fields?.file?.url && entry.fields.file?.fields.file?.url)
    .map((entry) => {
      if (!entry.fields?.cover?.fields?.file?.url || !entry.fields?.file?.fields?.file?.url) return null
      return {
        title: entry.fields.title,
        description: entry.fields.description,
        subscriptionType: entry.fields.subscriptionType,
        coverUrl: entry.fields.cover.fields.file.url,
        fileUrl: entry.fields.file.fields.file.url,
      }
    })
    .filter(isPresent)
}

export function getCurriculumMapsViewModel(entries: CurriculumMapEntry[]) {
  return (
    entries?.map((entry) => {
      return {
        title: entry.fields.title,
        description: entry.fields.description,
        subscriptionType: entry.fields.subscriptionType,
        coverUrl: entry.fields.cover?.fields.file?.url,
        fileUrl: entry.fields.file?.fields.file?.url,
      }
    }) || []
  )
}

export function getCertificatesViewModel(entries: CertificateEntry[], translationFn: (key: string) => string) {
  return (
    entries?.map((entry) => {
      return {
        title: entry.fields.title,
        description: entry.fields.colour
          ? translationFn('printables.mediaType.colourPdf')
          : translationFn('printables.mediaType.blackAndWhitePdf'),
        subscriptionType: entry.fields.subscriptionType,
        coverUrl: entry.fields.cover?.fields.file?.url,
        fileUrl: entry.fields.file?.fields.file?.url,
      }
    }) || []
  )
}
